import { tv, type VariantProps } from 'tailwind-variants'

import { cardVariants } from '../card/card-variants'

export const modalVariants = tv({
  extend: cardVariants,
  slots: {
    base: 'top-0 bg-transparent m-auto pb-6 w-full bg-default-bg-white',
    header: 'min-h-0 p-0',
    title: 'self-center mt-4 text-center',
    description: 'whitespace-pre-line',
    body: 'px-6 mt-4',
    footer: 'flex flex-row items-center justify-end gap-4 px-6 pt-4 pb-0',
    closeButton: 'relative self-end',
    handleContainer: 'items-center pt-3',
    handle: 'h-1 w-32 rounded-full bg-layout-divider-contrast-high',
  },
  variants: {
    phoneViewport: {
      true: {
        base: '!rounded-b-none mx-0 mb-0 p-1 w-full',
      },
    },
  },
  defaultVariants: {
    phoneViewport: false,
  },
  compoundVariants: [
    {
      fullWidth: false,
      class: { base: 'max-w-[500px]' },
    },
    {
      fullWidth: true,
      class: { base: 'lg:max-w-screen-lg' },
    },
  ],
})

export type TModalVariantProps = VariantProps<typeof modalVariants>
export type TModalSlots = keyof ReturnType<typeof modalVariants>
